/**
 * Typed query-key factory (knowledge-tree Step 8). Keys are hierarchical so
 * invalidations can target a whole domain: `qKeys.payments.all` resets E18 lists.
 */
export const qKeys = {
  session: ['auth', 'session'] as const,
  profile: ['user', 'me'] as const,
  avatar: {
    all: ['user', 'me', 'avatar'] as const,
    image: (userId: string, version: string | null | undefined) => ['user', 'me', 'avatar', userId, version ?? null] as const,
  },
  downline: ['hierarchy', 'downline'] as const,
  team: {
    all: ['team'] as const,
    level: (focus: string, filters: unknown) => ['team', 'level', focus, filters] as const,
    member: (userId: string) => ['team', 'member', userId] as const,
    installments: (userId: string, subscriptionId: string | undefined) => ['team', 'installments', userId, subscriptionId] as const,
    search: (q: string) => ['team', 'search', q] as const,
  },
  subscription: ['subscriptions', 'my'] as const,
  installments: (subscriptionId: string) => ['subscriptions', 'installments', subscriptionId] as const,
  commissions: {
    all: ['commissions'] as const,
    ledger: (params: unknown) => ['commissions', 'ledger', params] as const,
    summary: ['commissions', 'summary'] as const,
  },
  payments: {
    all: ['payments'] as const,
    history: (params: unknown) => ['payments', 'history', params] as const,
  },
  withdrawals: {
    all: ['withdrawals'] as const,
    payoutOptions: ['withdrawals', 'payout-options'] as const,
    history: (params: unknown) => ['withdrawals', 'history', params] as const,
  },
  notices: ['notices'] as const,
  dashboard: ['dashboard', 'stats'] as const,
} as const;
